import {
  FilterBoxCheckbox,
  FilterBoxSlider,
} from "@modules/study/common/advance_search/advance";
import UniThumbBoxMobile from "@modules/study/common/uni_thumb_box_mobile";
import UniThumbListBox from "@modules/study/common/uni_thumb_list_box";
import { CircularProgress } from "@mui/material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import CourseLoadingScreen from "@unisearch/common/loader/course_screen";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import {
  geneateSelectedOptions,
  generateOptions,
  slugToString,
} from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { objectToQueryString, slugToString2 } from "@unisearch/helpers/utils";
import { useRouter, withRouter } from "next/router";
import { Fragment, useEffect, useRef, useState } from "react";
import { BiMoney } from "react-icons/bi";
import { FiArrowLeft, FiFilter, FiX } from "react-icons/fi";

import styles from "./search_filter.module.scss";

export const SearchFilter2 = ({
  searchParams,
  location,
  courseLevel,
  specialization,
  examType,
  fees,
  courseDuration,
  filterResult,
  pageUrl,
  initSp,
  initCrlvl,
  initCo,
  ...props
}) => {
  const router = useRouter();
  const { refq } = router.query;
  const spFromPageUrl = pageUrl.split("/")[2];

  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };
  const [noDataFound, setNoDataFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterCollaps, setFilterCollaps] = useState(false);
  const [searchQuery, setSearchQuery] = useState(searchParams);
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [filterNum, setNumfilter] = useState(0);

  // const [locationsObj, setLocationsObj] = useState(location);
  // const [courseLevelsObj, setCourseLevelsObj] = useState(courseLevel);
  // const [specializationsObj, setSpecializationsObj] = useState(courseLevel);
  // const [examTypesObj, setExamTypesObj] = useState(examType);

  const [feesObj, setFeesObj] = useState(fees);
  const [durationObj, setDurationObj] = useState(courseDuration);

  const [pageData, setPageData] = useState([]);
  const [pagerOption, setPagerOption] = useState();

  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      router.push(`${pageUrl}?${objectToQueryString(searchQuery)}`);
    } else {
      isMounted.current = true;
    }
  }, [searchQuery]);

  //generating for selectbox and dropdown
  const [locationArray, setLocationArray] = useState([]);
  const [levelArray, setLevelArray] = useState([]);
  const [spArray, setSpArray] = useState([]);
  const [examArray, setExamArray] = useState([]);

  //selected States
  const [checkedState, setCheckedState] = useState({
    checkedLocations: [],
    expandedLocations: [],
    checkedLevels: [],
    expandedLevels: [],
    checkedSpecializations: [],
    expandedSpecializations: [],
    checkedExam: [],
    expandedExam: [],
  });

  //generate Locations
  const generateLocation = (country_slug = null) => {
    if (location && location.length > 0) {
      const stArray = searchQuery && searchQuery.st ? searchQuery.st : [];

      const selectedLocation = [];
      const expandLocation = [];

      const locationsData = location.map((country) => {
        return {
          label: country.name,
          value: country.slug,
          disabled: country.slug == country_slug ? true : false,
          children:
            country.state &&
            country.state.length > 0 &&
            country.state.map((state) => {
              if (country_slug && country_slug == country.slug) {
                selectedLocation.push(country.slug + "_" + state.slug);
                expandLocation.push(country.slug);
              } else if (stArray.includes(state.slug)) {
                selectedLocation.push(country.slug + "_" + state.slug);
                expandLocation.push(country.slug);
              }
              return {
                label: state.name,
                value: country.slug + "_" + state.slug,
                disabled: country.slug == country_slug ? true : false,
                children:
                  state.cities &&
                  state.cities.length > 0 &&
                  state.cities.map((city) => {
                    return {
                      label: city.name,
                      value: country.slug + "_" + state.slug + "_" + city.slug,
                    };
                  }),
              };
            }),
        };
      });

      //set location checked
      setTimeout(() => {
        setCheckedState((prevState) => ({
          ...prevState,
          checkedLocations: selectedLocation,
          expandedLocations: expandLocation,
        }));
      }, 0);

      //set location state
      setLocationArray(locationsData);
    } else {
      setLocationArray([]);
      setCheckedState((prevState) => ({
        ...prevState,
        checkedLocations: [],
        expandedLocations: [],
      }));
    }
  };

  useEffect(() => {
    generateLocation(initCo);
  }, [location]);

  //generate Levels
  const generateLevels = () => {
    if (courseLevel && courseLevel.length > 0) {
      const courseLevelData = generateOptions(
        courseLevel,
        "label",
        "slug",
        "child"
      );

      const selectedLevel = geneateSelectedOptions(
        courseLevel,
        searchQuery.crlvl,
        "slug",
        "child"
      );

      //set selected and expand
      setCheckedState((prevState) => ({
        ...prevState,
        expandedLevels: selectedLevel.expandOptions ?? [],
        checkedLevels: selectedLevel.selectedOptions ?? [],
      }));

      //set serach level data
      setLevelArray(courseLevelData);
    } else {
      setLevelArray([]);
    }
  };

  useEffect(() => {
    generateLevels();
  }, [courseLevel]);

  //generate Levels
  const generateSpecializations = () => {
    if (specialization && specialization.length > 0) {
      const spData = generateOptions(
        specialization,
        "label",
        "slug",
        "children"
      );
      //set specialization data array
      setSpArray(spData);

      //generate selected specialization
      const selectedSpl = geneateSelectedOptions(
        specialization,
        searchQuery.sp,
        "slug",
        "children"
      );
      //set selected and expand
      setCheckedState((prevState) => ({
        ...prevState,
        expandedSpecializations: selectedSpl.expandOptions ?? [],
        checkedSpecializations: selectedSpl.selectedOptions ?? [],
      }));
    } else {
      setSpArray([]);
    }
  };

  useEffect(() => {
    generateSpecializations();
  }, [specialization]);

  //Genreate Exams Type
  const generateExamType = () => {
    if (examType && examType.length > 0) {
      const spData = generateOptions(examType, "label", "slug");
      setExamArray(spData);

      //generate selected specialization
      const selectedEx = geneateSelectedOptions(
        examType,
        searchQuery.ex,
        "slug",
        "children"
      );
      //set selected and expand
      setCheckedState((prevState) => ({
        ...prevState,
        expandedExam: selectedEx.expandOptions ?? [],
        checkedExam: selectedEx.selectedOptions ?? [],
      }));
    } else {
      setExamArray([]);
    }
  };

  useEffect(() => {
    generateExamType();
  }, [examType]);

  //Search Locations
  const searchLocations = (value) => {
    setCheckedState((prevState) => ({ ...prevState, checkedLocations: value }));
    // expandedLocations

    let contries = [];
    let states = [];
    // let cities = [];

    if (value.length > 0) {
      value.map((loc) => {
        let locArr = loc.split("_");
        if (locArr[0]) contries.push(locArr[0]);
        if (locArr[1]) states.push(locArr[1]);
        // if (locArr[2]) cities.push(locArr[2]);
      });
    }

    setSearchQuery((prevState) => ({
      ...prevState,
      co: Array.from(new Set(contries)),
      st: Array.from(new Set(states)),
      page: 1,
    }));
  };

  const getLocationExpand = (value) => {
    setCheckedState((prevState) => ({
      ...prevState,
      expandedLocations: value,
    }));
  };

  //Search Levels
  const searchLevels = (value) => {
    setCheckedState((prevState) => ({
      ...prevState,
      checkedLevels: value,
    }));

    setSearchQuery((prevState) => ({
      ...prevState,
      crlvl: Array.from(new Set(value)),
      page: 1,
    }));
  };

  //search Specializations
  const searchSpcs = (value) => {
    setCheckedState((prevState) => ({
      ...prevState,
      checkedSpecializations: value,
    }));

    let specArray = [];
    if (value.length > 0) {
      value.map((loc) => {
        let splite_data = loc.split("_");
        specArray = specArray.concat(splite_data);
      });
    }

    setSearchQuery((prevState) => ({
      ...prevState,
      sp: Array.from(new Set(specArray)),
      page: 1,
    }));
  };

  const searchSpcsExpand = (value) => {
    setCheckedState((prevState) => ({
      ...prevState,
      expandedSpecializations: value,
    }));
  };

  //Search Levels
  const searchExamtype = (value) => {
    setCheckedState((prevState) => ({
      ...prevState,
      checkedExam: value,
    }));

    setSearchQuery((prevState) => ({
      ...prevState,
      ex: Array.from(new Set(value)),
    }));
  };

  const examtypeExpand = (value) => {
    setCheckedState((prevState) => ({
      ...prevState,
      expandedExam: value,
    }));
  };

  //reset all content
  const resetAll = async () => {
    delete searchQuery.ex;
    delete searchQuery.co;
    delete searchQuery.ci;
    delete searchQuery.st;
    delete searchQuery.crlvl;
    delete searchQuery.sp;
    delete searchQuery.tfees;
    delete searchQuery.duration;
    searchQuery.page = 1;

    setSearchQuery(searchQuery);

    //unchecked selected
    setCheckedState({
      checkedLocations: [],
      expandedLocations: [],
      checkedLevels: [],
      expandedLevels: [],
      checkedSpecializations: [],
      expandedSpecializations: [],
      checkedExam: [],
      expandedExam: [],
    });

    //get filtered data
    await getFilterData();
    //router push
    router.push(`${pageUrl}?${objectToQueryString(searchQuery)}`);
  };

  //Initial laoding
  let is_mounted = false;

  useEffect(() => {
    //set filter result and pagination
    let {
      page_total,
      totalCourseCount,
      total,
      currentPage,
      limit,
      results,
    } = filterResult;

    setPagerOption({ page_total, totalCourseCount, total, currentPage, limit });

    //set course results
    setPageData(results ?? []);

    //is no course found
    if (!totalCourseCount || totalCourseCount < 1) {
      setNoDataFound(true);
    }
  }, [pageUrl]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      // const controller = new AbortController();
      if (!is_mounted) {
        //get search data
        await getFilterData();

        //handle view More
        const generateShowMore = () => {
          if (
            searchQuery.st ||
            searchQuery.ci ||
            searchQuery.crlvl ||
            searchQuery.sp ||
            searchQuery.ex ||
            searchQuery.tfees ||
            searchQuery.duration
          ) {
            let filterLevelArray = [];

            if (searchQuery.st && searchQuery.st.length > 0) {
              filterLevelArray = [...filterLevelArray, ...searchQuery.st];
            }

            if (searchQuery.ci && searchQuery.ci.length > 0) {
              filterLevelArray = [...filterLevelArray, ...searchQuery.ci];
            }

            if (searchQuery.crlvl && searchQuery.crlvl.length > 0) {
              filterLevelArray = [...filterLevelArray, ...searchQuery.crlvl];
            }

            if (searchQuery.sp && searchQuery.sp.length > 0) {
              filterLevelArray = [...filterLevelArray, ...searchQuery.sp];
            }

            if (searchQuery.ex && searchQuery.ex.length > 0) {
              filterLevelArray = [...filterLevelArray, ...searchQuery.ex];
            }

            setNumfilter(filterLevelArray.length);

            if (filterLevelArray && parseInt(filterLevelArray.length) > 20) {
              setFilterCollaps(true);
            } else {
              setFilterCollaps(false);
            }
          }
        };

        //call generate show more function
        generateShowMore();
        //call generatedFilteredLocations
        generateFilteredLocation();

        // router.push(`${pageUrl}?${objectToQueryString(searchQuery)}`);
      }

      //set laoding false
      return setTimeout(setLoading(false), 1000);
      // return () => controller.abort();
    };
    fetchData();
  }, [searchQuery, pagerOption?.currentPage]);

  const generateFilteredLocation = () => {
    const filteredLocations = location.filter(
      (item) => searchQuery.co && searchQuery.co.includes(item.slug)
    );

    filteredLocations.map((item) => {
      item.filteredState =
        item.state &&
        item.state.filter(
          (st) => searchQuery.st && searchQuery.st.includes(st.slug)
        );
    });

    setFilteredLocations(filteredLocations);
  };

  //Get Search filter Data
  const getFilterData = async () => {
    await API.get(`/search?${objectToQueryString(searchQuery)}`)
      .then((response) => {
        if (!response.error && response.data) {
          let {
            page_total,
            totalCourseCount,
            total,
            currentPage,
            limit,
            results,
          } = response.data.filterResult;
          setPagerOption({
            page_total,
            totalCourseCount,
            total,
            currentPage,
            limit,
          });
          setPageData(results);
        }
      })
      .catch((err) => {});
  };

  //pagination handle
  const patinationHandler = (event, page) => {
    //update page on serach query
    setSearchQuery((prevState) => ({ ...prevState, page: page }));
  };

  //remove filter item
  const handleRemoveFilter = (filterType, slug) => {
    setLoading(true);

    if (filterType == "co") {
      let newLocations = filteredLocations.filter((co) => co.slug != slug);
      const country = [];
      const state = [];

      newLocations.map((co) => {
        country.push(co.slug);
        if (co.filteredState && co.filteredState.length > 0) {
          co.filteredState.map((st) => {
            state.push(st.slug);
          });
        }
      });

      setSearchQuery((prevState) => ({
        ...prevState,
        co: Array.from(new Set(country)),
        st: Array.from(new Set(state)),
      }));
      return true;
    }

    if (filterType == "st") {
      let searchCountry = [...searchQuery.co];

      const filteredCountry = location.filter(
        ({ state }) => state.filter((st) => st.slug == slug).length > 0
      )[0];

      const ActiveCountryState = filteredCountry?.state?.filter(
        (state) => state.slug !== slug && searchQuery.st?.includes(state.slug)
      );

      if (!ActiveCountryState || ActiveCountryState.length == 0) {
        searchCountry = searchCountry.filter(
          (item) => item !== filteredCountry.slug
        );
      }

      const states = searchQuery.st.filter((state) => state !== slug);
      setSearchQuery((prevState) => ({
        ...prevState,
        co: Array.from(new Set(searchCountry)),
        st: Array.from(new Set(states)),
      }));
      return true;
    }

    if (filterType == "crlvl") {
      let courseLevel = [...searchQuery.crlvl];
      const crlvl_states = courseLevel.filter((level) => level !== slug);
      setSearchQuery((prevState) => ({
        ...prevState,
        crlvl: Array.from(new Set(crlvl_states)),
      }));
      return true;
    }

    if (filterType == "sp") {
      let courseSP = [...searchQuery.sp];
      const sp_states = courseSP.filter((sp) => sp !== slug);
      setSearchQuery((prevState) => ({
        ...prevState,
        sp: Array.from(new Set(sp_states)),
      }));
      return true;
    }

    if (filterType == "ex") {
      let courseEX = [...searchQuery.ex];
      const ex_states = courseEX.filter((ex) => ex !== slug);
      setSearchQuery((prevState) => ({
        ...prevState,
        ex: Array.from(new Set(ex_states)),
      }));
      return true;
    }
  };

  //Search By Fees
  const searchByFees = (value) => {
    setSearchQuery((prevState) => ({
      ...prevState,
      tfees: value,
      page: 1,
    }));
  };

  //Search By Duration
  const searchByDuration = (value) => {
    setSearchQuery((prevState) => ({
      ...prevState,
      duration: value,
      page: 1,
    }));
  };

  const MoreBtn = () => {
    let lengthRemove = 0;
    filteredLocations.map((locat) => {
      if (locat.filteredState.length === locat.state.length) {
        lengthRemove = lengthRemove + parseInt(locat.state.length) - 1;
      }
    });

    if (filterCollaps && parseInt(filterNum - lengthRemove) > 20) {
      return (
        <button
          className={styles.moreBtn}
          onClick={(e) => {
            setFilterCollaps(false);
          }}
        >
          <span> More ...</span>
        </button>
      );
    }
    return "";
  };

  // Left side content
  const LeftSide = () => {
    return (
      <Fragment>
        <div className={styles.filter_title_reset}>
          <div className={styles.title}> Filters </div>
          {((checkedState && checkedState.checkedLocations.length > 0) ||
            (checkedState && checkedState.checkedLevels.length > 0) ||
            (checkedState && checkedState.checkedSpecializations.length > 0) ||
            (checkedState && checkedState.checkedExam.length > 0)) && (
            <button className={styles.reset} onClick={resetAll}>
              Reset All
            </button>
          )}
        </div>
        <div className={styles.filter_option_wrapper}>
          {locationArray && locationArray.length > 0 && (
            <div className="filter_location">
              <FilterBoxCheckbox
                data={locationArray}
                onChange={searchLocations}
                getExpand={getLocationExpand}
                selected={checkedState.checkedLocations}
                expanded={checkedState.expandedLocations}
                title={`Location`}
                search={true}
                loading={loading}
              />
            </div>
          )}
          {levelArray && levelArray.length > 0 && (
            <div className="filter_course_level">
              <FilterBoxCheckbox
                onChange={searchLevels}
                // data={levelArray}
                data={levelArray.map((item) => {
                  if (item.value == initCrlvl) {
                    return { ...item, disabled: true };
                  }
                  return item;
                })}
                selected={checkedState.checkedLevels}
                title={`Course Level`}
                loading={loading}
              />
            </div>
          )}
          {spArray && spArray.length > 0 && (
            <div className="filter_specialization">
              <FilterBoxCheckbox
                onChange={searchSpcs}
                getExpand={searchSpcsExpand}
                selected={checkedState.checkedSpecializations}
                expanded={checkedState.expandedSpecializations}
                // data={spArray}
                data={spArray.map((item) => {
                  if (item.value == initSp) {
                    return { ...item, disabled: true };
                  }
                  return item;
                })}
                title={`Specialization`}
                loading={loading}
              />
            </div>
          )}
          {/* <FilterBoxSlider title={`Fees & Expenses`} /> */}
          {examArray && examArray.length > 0 && (
            <div className="filter_exam">
              <FilterBoxCheckbox
                data={examArray}
                onChange={searchExamtype}
                getExpand={examtypeExpand}
                expanded={checkedState.expandedExam}
                selected={checkedState.checkedExam}
                title={`Eligibility Exam`}
                loading={loading}
              />
            </div>
          )}

          {durationObj && durationObj.maxDuration > 0 && (
            <FilterBoxSlider
              title={`Course Duration`}
              range={[
                parseInt(durationObj.minDuration),
                parseInt(durationObj.maxDuration),
              ]}
              value={
                searchQuery?.duration && searchQuery?.duration.length == 2
                  ? [
                      parseInt(searchQuery.duration[0]),
                      parseInt(searchQuery.duration[1]),
                    ]
                  : [
                      parseInt(durationObj.minDuration),
                      parseInt(durationObj.maxDuration),
                    ]
              }
              onChange={searchByDuration}
              loading={loading}
              icon="m"
              offset="right"
            />
          )}

          {feesObj && parseInt(feesObj.maxAmount) > 0 && (
            <FilterBoxSlider
              title={`Tution Fees(First Year)`}
              range={[parseInt(feesObj.minAmount), parseInt(feesObj.maxAmount)]}
              value={
                searchQuery?.tfees && searchQuery?.tfees.length == 2
                  ? [
                      parseInt(searchQuery.tfees[0]),
                      parseInt(searchQuery.tfees[1]),
                    ]
                  : [parseInt(feesObj.minAmount), parseInt(feesObj.maxAmount)]
              }
              onChange={searchByFees}
              loading={loading}
              icon={<BiMoney />}
              offset="left"
            />
          )}

          {/* searchQuery.tfees ? searchQuery.tfees :  */}
        </div>

        <div className={styles.filter_all_btn_wrapper}>
          <button className={`btn btn-outline btn-sm`} onClick={resetAll}>
            Reset All
          </button>
          <button
            className={`btn btn-primary btn-sm`}
            onClick={() => setDrawerOpen(false)}
          >
            Apply All Filters
          </button>
        </div>
      </Fragment>
    );
  };

  // Right side content
  const RightSide = () => {
    return (
      <Fragment>
        <div className={styles.uni_box_wrapper}>
          {(loading ? Array.from(new Array(6)) : pageData).map(
            (item, index) => {
              if (item) {
                return (
                  <Fragment key={`search_${index}`}>
                    <div className={styles.thumb_box_desktop}>
                      <UniThumbListBox item={item} />
                    </div>
                    <div
                      className={styles.thumb_box_mobile}
                      key={`mob_search_${index}`}
                    >
                      <UniThumbBoxMobile item={item} />
                    </div>
                  </Fragment>
                );
              } else {
                return <CourseLoadingScreen key={`search_${index}`} />;
              }
            }
          )}

          {!loading && pagerOption && pagerOption.total > 10 && (
            <PaginationComponent
              paginate={pagerOption}
              paginationHandler={patinationHandler}
            />
          )}
        </div>
      </Fragment>
    );
  };

  if (!noDataFound) {
    return (
      <Fragment>
        <section className={styles.section_search_hero}>
          <div className="container">
            <div className={styles.hero_content_wrapper}>
              <div className={styles.search_result_text}>
                {pagerOption && pagerOption?.totalCourseCount}{" "}
                {pagerOption?.totalCourseCount > 1 ? "courses" : "course"} found
                in {pagerOption && pagerOption?.total}{" "}
                {pagerOption?.total > 1 ? "universities" : "University"}{" "}
                {searchQuery?.refq || searchQuery?.sp?.length > 0 ? "for " : ""}
                <br />
                <span className="capitalize">
                  {slugToString2(spFromPageUrl)} Courses{" "}
                  {searchQuery?.co ? (
                    <>
                      <span className="normal-case">in</span>{" "}
                      {slugToString2(searchQuery?.co)}
                    </>
                  ) : (
                    "Abroad"
                  )}
                </span>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.section_search_filter}>
          <div className="container">
            <div className={styles.filter_and_indector_wrapper}>
              <div className={styles.filter_btn_wrapper}>
                <button
                  onClick={() => setDrawerOpen(true)}
                  className={styles.btn_filter}
                >
                  <FiFilter /> <span>FIlter</span>
                </button>
              </div>
            </div>

            <div className={`${styles.wrapper}`}>
              <div className={styles.filter_desktop}>
                <LeftSide />
              </div>
              <RightSide />
            </div>
          </div>
        </section>

        <SwipeableDrawer
          anchor="left"
          classes={{
            paper: `SearchFilterDrawer ${styles.search_filter_drawer}`,
          }}
          open={drawerOpen}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          disableSwipeToOpen={false}
          ModalProps={{ keepMounted: true }}
        >
          <div className={styles.filter_drawer}>
            <div className={styles.filter_drawer_head}>
              <h4 className={styles.filter_title}>Filter Your Result</h4>
              <FiX
                onClick={() => setDrawerOpen(false)}
                className={styles.close_icon}
              />
            </div>
            <LeftSide />
          </div>
        </SwipeableDrawer>
      </Fragment>
    );
  }

  const generalSearch = () => {
    if (loading) {
      return (
        <div
          className="container"
          style={{ display: "grid", placeItems: "center", height: "50vh" }}
        >
          <CircularProgress />
        </div>
      );
    } else {
      if (
        filterResult &&
        filterResult?.results?.length === 1 &&
        filterResult?.results[0].slug &&
        filterResult?.results[0].course?.length === 0
      ) {
        router.push(
          `/study/${filterResult?.results[0].country?.slug}/university/${filterResult?.results[0].slug}`
        );
      } else {
        return (
          <Fragment>
            <div className={styles.soft_bg}></div>
            <section className={styles.section_noresult}>
              <div className="container">
                <div className={styles.noresult_text_wrapper}>
                  <h1 className={styles.noresult_title}>
                    We did not find any results for <br /> "
                    {refq ?? searchQuery?.refq}"
                  </h1>
                  <p className={styles.noresult_sub_text}>
                    Click here to begin your search again.
                  </p>
                  <button
                    type="button"
                    onClick={() => router.push("/")}
                    className={`btn btn-secondary btn-bg ${styles.noresult_btn}`}
                  >
                    <FiArrowLeft style={{ fontSize: "18px" }} /> Back to Home
                  </button>
                </div>
              </div>
            </section>
          </Fragment>
        );
      }
    }
  };

  return <>{generalSearch()}</>;
};

export default SearchFilter2;
